export default __webpack_public_path__ + "static/media/solution_04.9241720e.png";